import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        {/* Main Footer */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white">蜜桃在线</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              蜜桃在线是您发现优质高清视频内容的首选平台。海量资源持续更新，流畅播放体验，支持多终端访问。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors">首页</Link>
              <Link to="/category/dianying" className="text-sm text-background-400 hover:text-white transition-colors">电影</Link>
              <Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-white transition-colors">电视剧</Link>
              <Link to="/category/zongyi" className="text-sm text-background-400 hover:text-white transition-colors">综艺</Link>
              <Link to="/category/dongman" className="text-sm text-background-400 hover:text-white transition-colors">动漫</Link>
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">帮助与支持</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">常见问题</a>
              <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">用户协议</a>
              <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">版权声明</a>
              <Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors">关于我们</Link>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">订阅更新</h4>
            <p className="text-sm text-background-400 mb-3">第一时间获取最新资源上架通知</p>
            {submitted ? (
              <div className="flex items-center gap-2 text-accent-400 text-sm">
                <i className="ri-checkbox-circle-line"></i>
                订阅成功！感谢关注。
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="px-4 py-2.5 bg-background-800 border border-background-700 rounded-lg text-sm text-white placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即订阅
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 蜜桃在线 版权所有 | 本站所有内容均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>京ICP备2024XXXXXX号</span>
            <span>京公网安备 110XXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}